var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('mainMenu',{ref:"mainmenu",attrs:{"sid":"/Admin/NwLed"}}),_c('div',{staticClass:"subrouter"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }